import {Service, signal} from '@angular/core'

@Service()
export class ProgressIndicatorService {
  public progressRunning = signal<boolean>(false)
}
